import { of, concat } from 'rxjs'
import { concatMap, switchMap } from 'rxjs/operators'
import {
  createClearLoading$,
  createLoading$,
} from '@apiEnabler/api-enabler-common/lib/loading'
import { createStoreNavigateTo$ } from './navigation'
import {
  updateStandingOrderHistoryState,
  updateStandingOrderActivityState,
  updateStandingOrdersGeneratedState$,
} from '@apiEnabler/ob-common/lib/standing-order-consents'

import { initialData$ } from './customer'
import { createGetPaymentHistory$ } from './services'
import { displaySOPayments$, displaySOPaymentDetails$ } from './intents'

const createLoadPaymentHistory$ = paymentId =>
  createGetPaymentHistory$(paymentId).pipe(
    concatMap(activityAudits =>
      of(
        updateStandingOrderHistoryState(paymentId, activityAudits),
        updateStandingOrderActivityState(paymentId, activityAudits)
      )
    )
  )

export const soPaymentsDisplay$ = displaySOPayments$.pipe(
  switchMap(() =>
    concat(
      initialData$,
      createLoading$('Loading standing orders'),
      createStoreNavigateTo$('/recurring-payments/standing-orders'),
      updateStandingOrdersGeneratedState$,
      createClearLoading$('Loading standing orders')
    )
  )
)

export const soPaymentDetailsDisplay$ = displaySOPaymentDetails$.pipe(
  switchMap(paymentId =>
    concat(
      initialData$,
      createLoading$('Loading standing order details'),
      createStoreNavigateTo$(
        `/recurring-payments/standing-orders/${paymentId}`
      ),
      updateStandingOrdersGeneratedState$,
      createLoadPaymentHistory$(paymentId),
      createClearLoading$('Loading standing order details')
    )
  )
)
